import { HelpCircle, Shuffle, Play } from "lucide-react";
import React, {useEffect, useState} from "react";
import * as motion from "motion/react-client";
import ToggleButton from "../../ui/ToggleButton";
import BounceCheckbox from "../../ui/BounceCheckbox";
import { TrainingOptions } from "../../pages/math/.utils/operatorUtils";
import {tab} from "@testing-library/user-event/dist/tab";
import TableCheckbox from "../../ui/TableCheckbox";

type Props = {
    updateSettingsFn: (settings: TrainingOptions) => void;
    currentSettings?: TrainingOptions;
}
const MathSettingsDialog = ({ updateSettingsFn, currentSettings }: Props) => {

    const [dialogOpen, setDialogOpen] = useState(false)
    const [useHelper, setUseHelper] = useState(false);
    const [shuffle, setShuffle] = useState(false);
    const [allTables, _setAllTables] = useState(false);
    // const [bCheckbox, setBCheckbox] = useState(false);
    const [tables, setTables] = useState<boolean[]>(Array.from({ length: 12 }, (_, i) => {
        return currentSettings?.Tables?.includes(i + 1) ?? false
    }));
    const tableSelect = (index: number) => {
        const newTables = [...tables];
        newTables[index] = !newTables[index];
        setTables(newTables);
    }
    const setAllTables = (value: boolean) => {
        setTables(tables.map(() => value));
    }
    useEffect(() => {
        if (currentSettings) {
            if (currentSettings.Helper) setUseHelper(true);
            if (currentSettings.Shuffle) setShuffle(true);
        }
    }, [currentSettings]);
    const setSettings = () => {
        console.log("Use helper: ", useHelper)
        console.log("Shuffling: ", shuffle)
        console.log("Tables: ", tables)
        // console.log("All tables: ", allTables)
        let opts = undefined as TrainingOptions | undefined;
        if (allTables) {
            console.log("All tables are selected. Continue.")
            opts = {
                Tables: tables.flatMap((_, i) => i + 1),
                Shuffle: shuffle,
                Helper: useHelper,
                reset: false,
                ready: true,
            }
            // updateSettingsFn(opts)
        }
        if (tables.some(t => t)) {
            console.log("Some tables are selected. Continue.")
            opts = {
                Tables: tables.flatMap((t, i) => t ? i + 1 : []),
                Shuffle: shuffle,
                Helper: useHelper,
                reset: true,
                ready: true,
            }
            // updateSettingsFn(opts)
        }
        if (opts) {
            updateSettingsFn(opts)
        }
    }
    useEffect(() => {
        _setAllTables((tables.every(t => t)))
    }, [tables]);
    return (<div className="flex flex-col gap-4">

        <motion.h2 className="font-extrabold text-2xl">
            Settings
        </motion.h2>
        <div className="grid grid-cols-[40px_1fr_40px] gap-4 items-center">
            <ToggleButton value={useHelper} onChange={setUseHelper} />
            <div>
                Helper: see the answer for each question.
            </div>
            <HelpCircle className={`${useHelper ? "text-gray-100" : "text-gray-500"} w-8 h-8`} />
        </div>
        <div className="grid grid-cols-[40px_1fr_40px] gap-4 items-center">
            <ToggleButton value={shuffle} onChange={setShuffle} />
            Shuffle the questions.
            <Shuffle className={`${shuffle ? "text-gray-100" : "text-gray-500"} w-8 h-8`} />
        </div>
        <div>
            <motion.h3 className="font-extrabold text-xl"
                       initial={{ opacity: 0, y: -10 }}
                       animate={{ opacity: 1, y: 0 }}
                       transition={{ duration: 0.4 }}>
                Tables
            </motion.h3>
        </div>
        <div className="grid grid-cols-4 flex-wrap gap-4 items-center">
            {tables.map((_, index) => (
                <TableCheckbox
                    checked={tables[index]}
                    text={`${index + 1}'s`}
                    onChange={() => tableSelect(index)}
                />
            ))}
        </div>
        {/*<div className="grid grid-cols-[1fr_1fr_1fr_1fr] gap-2 items-center">*/}
        {/*    {tables.map((_, index) => (*/}
        {/*        <div key={`multip-table-${index}`} className="flex items-center gap-2 ">*/}
        {/*            <BounceCheckbox checked={tables[index]} children={<>H</>} onChange={() => tableSelect(index)} />{`${index + 1}'s`}*/}
        {/*        </div>*/}
        {/*    ))}*/}
        {/*</div>*/}
        {/*<div className="flex items-center gap-2 font-extrabold py-4">*/}
        {/*    /!*<BounceCheckbox checked={!tables.some(t => !t)} onChange={() => setAllTables(!allTables)} />All tables*!/*/}
        {/*    <TableCheckbox checked={!tables.some(t => !t)}*/}
        {/*                   text={"Select"}*/}
        {/*                   onChange={() => setAllTables(!allTables)} />All tables*/}
        {/*</div>*/}
        <div className="flex items-center gap-2 font-extrabold py-4">
            {/*<BounceCheckbox checked={!tables.some(t => !t)} onChange={() => setAllTables(!allTables)} />All tables*/}
            <TableCheckbox checked={!tables.some(t => !t)}
                           text={"All tables"}
                           onChange={() => setAllTables(!allTables)} />
        </div>
        <div className={"flex w-full justify-center"}>
            <motion.button className={`
            ${tables.some(t => t) ? "bg-green-500 hover:bg-green-600" : "bg-transparent text-gray-500"} 
            px-4 py-2 w-1/3 transition-colors grid grid-cols-2 rounded-xl
            `}
                           onClick={() => setSettings()}>
                Start <Play />
            </motion.button>
        </div>
    </div>)
}

export default MathSettingsDialog;